const bootstrap = require('../../public/assets/libs/bootstrap/js/bootstrap.bundle.min');

